/**
 * Converts a string into a base64 encoded string
 *
 * @param str - The original string
 * @returns a base64 encoded string
 */
export function toBase64(str: string): string {
    return Buffer.from(str).toString('base64');
}
